export type UnitPreference = 'km' | 'mi';

const KM_TO_MI = 0.621371192;

export function normalizeUnit(value?: string | null): UnitPreference {
  return value === 'mi' ? 'mi' : 'km';
}

export function kmToUnit(km: number, unit: UnitPreference): number {
  return unit === 'mi' ? km * KM_TO_MI : km;
}

export function unitToKm(value: number, unit: UnitPreference): number {
  return unit === 'mi' ? value / KM_TO_MI : value;
}

export function distanceUnitLabel(unit: UnitPreference): string {
  return unit === 'mi' ? 'mi' : 'km';
}

export function speedUnitLabel(unit: UnitPreference): string {
  return unit === 'mi' ? 'mph' : 'km/h';
}

export function formatDistanceKm(km: number, unit: UnitPreference, digits = 0): string {
  return `${kmToUnit(km, unit).toFixed(digits)} ${distanceUnitLabel(unit)}`;
}

export function formatSpeedKmh(kmh: number, unit: UnitPreference): string {
  return `${Math.round(kmToUnit(kmh, unit))} ${speedUnitLabel(unit)}`;
}
